import angular from 'angular';

import EventDateModalComponent from './event-date-modal.cmpt';

export default angular
    .module('application.component.modals.component.event-date-modal', [])
    .component(EventDateModalComponent.selector, EventDateModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-date-modal/index.js